module.exports = __webpack_public_path__ + "img/75571.f962b913.svg";